// v2.5.0 — Route /delivery (rétro-compat) : redirection client-side vers /navigate
// en préservant le querystring (?dest=&code=&label=).

import { Navigate, useLocation } from "react-router-dom";

export default function DeliveryRedirect() {
  const loc = useLocation();
  return <Navigate to={"/navigate" + (loc.search || "")} replace />;
}
